import React, { useState, useEffect } from "react";
import axios from "axios";

import { Form, Button, Col, Row } from "react-bootstrap";

export default function EmpRegForm(props) {
  const AccountData = [{ value: "emp", option: "Employee" }];

  const [RoleData, setRoleData] = useState([]);
  const [PositionData, setPositionData] = useState([]);
  const [DepartmentData, setDepartmentData] = useState([]);

  const loadRegData = () => {
    axios
      .get("https://almawridems.javedahmadghamidi.com/api/ems/regData", {
        headers: {
          authorization: localStorage.getItem("token") || "",
        },
      })
      .then((response) => {
        setRoleData(response.data.Roles);
        setPositionData(response.data.Positions);
        setDepartmentData(response.data.Departments);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    loadRegData();
  }, []);

  return (
    <div>
      <h2 id="role-form-title">Register Yourself</h2>

      <div id="role-form-outer-div">
        <Form id="form" onSubmit={props.onEmployeeSubmit}>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Email
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control type="email" placeholder="Email" required />
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Password
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control type="password" placeholder="Password" required />
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Account access
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control
                name="ary[]"
                as="select"
                required
                values={AccountData}>
                <option deafult selected value="emp">
                  Employee
                </option>
              </Form.Control>
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Role
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control as="select" name="role">
                <option disabled selected>
                  Select your option
                </option>
                {RoleData.map((data, index) => (
                  <option key={index} value={data["_id"]}>
                    {data["RoleName"]}
                  </option>
                ))}
              </Form.Control>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label as="legend" column sm={2}>
              Gender
            </Form.Label>
            <Col sm={10}>
              <Form.Check
                inline
                type="radio"
                label="Male"
                value="male"
                name="gender"
                onChange={props.onGenderChange}
                required
              />
              <Form.Check
                inline
                type="radio"
                label="Female"
                value="female"
                name="gender"
                onChange={props.onGenderChange}
                required
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              First Name
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control type="text" placeholder="First Name" required />
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Middle Name
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control type="text" placeholder="Middle Name" />
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Last Name
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control type="text" placeholder="Last Name" required />
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              DOB
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control type="date" placeholder="DOB" required />
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Contact No
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control type="text" placeholder="Contact No " required />
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Employee Code
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control type="text" placeholder="Employee Code" required />
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Department
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control as="select" name="department" required>
                <option value="" disabled selected>
                  Select your option
                </option>
                {DepartmentData.map((data, index) => (
                  <option key={index} value={data["_id"]}>
                    {data["DepartmentName"]}
                  </option>
                ))}
              </Form.Control>
            </Col>
          </Form.Group>

          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Position
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control as="select" name="position" required>
                <option value="" disabled selected>
                  Select your option
                </option>
                {PositionData.map((data, index) => (
                  <option key={index} value={data["_id"]}>
                    {data["PositionName"]}
                  </option>
                ))}
              </Form.Control>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Date Of Joining
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control
                type="date"
                placeholder="Date Of Joining"
                required
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Terminate Date
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control type="date" placeholder="Terminate Date" />
            </Col>
          </Form.Group>

          <Form.Group as={Row} id="form-submit-button">
            <Col sm={{ span: 10, offset: 2 }}>
              <Button type="submit">Submit</Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row} id="form-cancel-button">
            <Col sm={{ span: 10, offset: 2 }} id="form-cancel-button-inner">
              <Button type="reset" onClick={props.onFormClose}>
                cancel
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </div>

      {/* </div>
        </div> */}
    </div>
  );
}
